import React from "react";
import "../App.css";

export default function AboutUs() {
  return (
    <section id="about" className="about-section">
      
      {/* --- About Intro Section --- */}
      <div className="about-intro">
        <div className="intro-left">
          <img 
            src="/photo-1586105251261-72a756497a11.avif" 
            alt="About"
            className="intro-img"
          />
          
        </div>

        <div className="intro-right">
          <h2>About Us</h2>
          <p>
            We are a trusted Real Estate Channel Partner in Bangalore, connecting 
            buyers with premium residential and commercial properties from 
            reputed developers.
          </p>
          <p>
            With strong builder relationships, transparent processes, and 
            zero brokerage, we help clients find the right property effortlessly.
          </p>
        </div>
      </div>

      {/* --- Vision & Mission --- */}
      <div className="vision-mission">
        <div className="vm-card">
          <h3>Vision</h3>
          <p>
            To create an ecosystem where property buying becomes simple, 
            transparent and guided with expert planning.
          </p>
          <ul>
            <li>✔ Trustworthy guidance</li>
            <li>✔ Zero brokerage support</li>
            <li>✔ Expert planning</li>
            <li>✔ Customer-first approach</li>
          </ul>
        </div>

        <div className="vm-card">
          <h3>Mission</h3>
          <p>
            To provide customers a seamless experience by offering verified 
            property options, expert assistance and end-to-end support.
          </p>
          <ul>
            <li>✔ Transparent Process</li>
            <li>✔ Verified Builder Projects</li>
            <li>✔ Hassle-Free Documentation</li>
            <li>✔ Lifetime Customer Support</li>
          </ul>
        </div>
      </div>

      {/* --- Core Values --- */}
      <div className="core-values">
        <h2>Our Core Values</h2>

        <div className="values-grid">

          <div className="value-box">
            <h4>Integrity</h4>
            <p>We work with honesty and transparency in every decision.</p>
          </div>

          <div className="value-box">
            <h4>Professionalism</h4>
            <p>We maintain high ethics & set a benchmark in real estate services.</p>
          </div>

          <div className="value-box">
            <h4>Commitment</h4>
            <p>Your property journey becomes our responsibility — end to end.</p>
          </div>

        </div>
      </div>

    </section>
  );
}
